var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_608_26489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.999 1.20117V6.00117M5.99902 1.20117V6.00117",
    stroke: "#35d169",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19922 9.60176C1.19922 7.33856 1.19922 6.20816 1.90242 5.50496C2.60562 4.80176 3.73602 4.80176 5.99922 4.80176H17.9992C20.2624 4.80176 21.3928 4.80176 22.096 5.50496C22.7992 6.20816 22.7992 7.33856 22.7992 9.60176V10.8018H1.19922V9.60176Z",
    stroke: "#35d169",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3992 4.80176H3.59922C2.27374 4.80176 1.19922 5.87627 1.19922 7.20176V20.4018C1.19922 21.7272 2.27374 22.8018 3.59922 22.8018H20.3992C21.7247 22.8018 22.7992 21.7272 22.7992 20.4018V7.20176C22.7992 5.87627 21.7247 4.80176 20.3992 4.80176Z",
    stroke: "#35d169",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7998 15.6006H9.59981M14.3998 15.6006H19.1998M4.7998 19.2006H9.59981M14.3998 19.2006H19.1998",
    stroke: "#35d169",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_608_26489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.0c663c6cac467eb989b6c69310b27c9a.svg";
export { ForwardRef as ReactComponent };